module.exports = __webpack_public_path__ + "img/template.700d6eaa.svg";